import React from "react";
import { Modal, Tree, Input  } from "antd";
import "./selectColumn.scss";
import Scrollbars from "react-custom-scrollbars";

const { TreeNode } = Tree;
const { Search } = Input;

const x = 3;
const y = 2;
const z = 1;
const gData = [];

const generateData = (_level, _preKey, _tns) => {
  const preKey = _preKey || '0';
  const tns = _tns || gData;

  const children = [];
  for (let i = 0; i < x; i++) {
    const key = `${preKey}-${i}`;
    tns.push({ title: key, key });
    if (i < y) {
      children.push(key);
    }
  }
  if (_level < 0) {
    return tns;
  }
  const level = _level - 1;
  children.forEach((key, index) => {
    tns[index].children = [];
    return generateData(level, key, tns[index].children);
  });
};
generateData(z);

const dataList = [];
const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const { key } = node;
    dataList.push({ key, title: key });
    if (node.children) {
      generateList(node.children);
    }
  }
};
generateList(gData);

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

class SelectColumn extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            visible: false,
            searchValue: '',

        }
       
    }

    showSelectColumn = () => {
        this.setState({
            visible: true
        })
    }

    handleOk = () => {
        this.setState({
            visible:false
        })
    }

    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    onChange = () => {

    }

    renderTreeContent = (data) =>{
        // for(let i=0; i<data.length; i++){
        //     if(data[i].children){
        //         return <TreeNode key={data[i].key} title={data[i].title}>{this.renderTreeContent(data[i].children)}</TreeNode>
        //     } else {
        //         return <TreeNode key={data[i].key} title={data[i].title}></TreeNode>
        //     }
        // }
        
        data.map((item, index) => {
            if (item.children) {
                return (
                  <TreeNode key={item.key} title={item.title}>
                    {this.renderTreeContent(item.children)}
                  </TreeNode>
                );
              }
              return <TreeNode key={item.key} title={item.title} />;
        })
    }

    render(){
        const { visible, value } = this.state;
        const loop = data =>
        data.map(item => {
            if (item.children) {
                return (
                  <TreeNode key={item.key} title={item.title}>
                    {loop(item.children)}
                  </TreeNode>
                );
              }
              return <TreeNode key={item.key} title={item.title} />;
        //   if (item.children) {
        //     return (
        //       <TreeNode key={item.key} title={item.title}>
        //         {loop(item.children)}
        //       </TreeNode>
        //     );
        //   }
        //   return <TreeNode key={item.key} title={item.title} />;
        });
        return(
            <Modal
                className="select-column-modal"
                title="选择栏目"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose
            >
                <div className="wrap">
                <Search style={{ marginBottom: 8 }} placeholder="Search" onChange={this.onChange} />
                 <Scrollbars style={{ height: 400}}>
                 <Tree
        //   onExpand={this.onExpand}
        //   expandedKeys={expandedKeys}
        //   autoExpandParent={autoExpandParent}
        >
          {loop(gData)}
        </Tree>

                 </Scrollbars>
                </div>
            </Modal>
            
        )
    }
}

export default SelectColumn;